import { useEffect } from "react";
import { useFormik } from "formik";

import { Input } from "../../Shared/Input";
import "./index.css";

function VideoWidgetContent(props) { 
  const { video_url } = props;
  const formik = useFormik({
    initialValues: {
      videoURL: video_url.length > 0 ? video_url : '',
    }
    // validationSchema: {},
  });

  function updateWidgets() {
    props.onSetWidgets("video_url", formik.values.videoURL);
  }

  // TODO: This keep us from having to add a update/save button
  // Within the video widget. Maybe this is good maybe we need to change?
  useEffect(updateWidgets, [formik.values.videoURL])
  
  return (
    <div className="VideoWidgetContent">
      <Input
        id='videoURL'
        type='text'
        label="YouTube or Vimeo link"
        name='videoURL'
        error={formik.touched.videoURL && formik.errors.videoURL}
        {...formik.getFieldProps('videoURL')}
      />
    </div>
  )
}

export default VideoWidgetContent;
